import { readable } from 'svelte/store';

/**
 * The time, ticking every second, for the live timers. Set again on start,
 * since the store outlives its subscribers and would hand a new one the
 * time it stopped at.
 */
export const now = readable(Date.now(), (set) => {
  set(Date.now());
  const id = setInterval(() => set(Date.now()), 1_000);
  return () => clearInterval(id);
});
